// PlanDetailModalContext.tsx
import React, { ReactNode, createContext, useContext, useState } from 'react'

import { MNonSupplementPlan } from '../interface/quotes/mNonSupplementPlans/MNonSupplementPlan'

interface PlanDetailModalContextType {
  openModal: (planId: string, planType: 'ma' | 'ms' | 'mpd') => void
  closeModal: () => void
  isModalOpen: boolean
  planId: string | null
  planType: 'ma' | 'ms' | 'mpd' | null
  mnsPlanDetails?: MNonSupplementPlan
}

const PlanDetailModalContext = createContext<
  PlanDetailModalContextType | undefined
>(undefined)

export const PlanDetailModalProvider = ({
  children,
}: {
  children: ReactNode
}) => {
  const [isModalOpen, setModalOpen] = useState(false)
  const [planId, setPlanId] = useState<string | null>(null)
  const [planType, setPlanType] = useState<'ma' | 'ms' | 'mpd' | null>(null)
  const [mnsPlanDetails, setMNSPlanDetails] = useState<
    MNonSupplementPlan | undefined
  >(undefined)

  const openModal = (
    id: string,
    type: 'ma' | 'ms' | 'mpd',
    mnsPlanDetails?: MNonSupplementPlan
  ) => {
    setPlanId(id)
    setPlanType(type)
    setModalOpen(true)
    if (mnsPlanDetails) setMNSPlanDetails(mnsPlanDetails)
  }

  const closeModal = () => {
    setPlanId(null)
    setPlanType(null)
    setMNSPlanDetails(undefined)
    setModalOpen(false)
  }

  return (
    <PlanDetailModalContext.Provider
      value={{
        openModal,
        closeModal,
        isModalOpen,
        planId,
        planType,
        mnsPlanDetails,
      }}
    >
      {children}
    </PlanDetailModalContext.Provider>
  )
}

export const usePlanDetailModal = () => {
  const context = useContext(PlanDetailModalContext)
  if (!context) {
    throw new Error(
      'usePlanDetailModal must be used within a PlanDetailModalProvider'
    )
  }
  return context
}
